import TextArea from "./TextArea.mjs";
export * from "./TextArea.mjs";
var lib_default = TextArea;
export {
  lib_default as default
};
